/* Re-evaluate the actual translated menu width instead of assuming every language fits. */
(() => {
  function setup(header) {
    if (header.dataset.waResponsiveReady) return;
    header.dataset.waResponsiveReady = 'true';
    const row = header.querySelector('.site-header__inner');
    const menu = row?.querySelector('.site-header__center.site-header__menu');
    const nav = menu?.querySelector('.f-site-nav__list');
    const left = row?.querySelector('.site-header__left');
    const right = row?.querySelector('.site-header__right');
    if (!nav || !left || !right) return;
    let queued = false;
    const measure = () => {
      queued = false;
      if (window.innerWidth < 1280) {
        header.classList.remove('wa-header-compact');
        return;
      }
      header.classList.add('wa-header-measuring');
      const menuWidth = [...nav.children].reduce((width, item) => width + item.getBoundingClientRect().width, 0);
      const needed = menuWidth + left.getBoundingClientRect().width + right.getBoundingClientRect().width + 48;
      header.classList.toggle('wa-header-compact', needed > row.clientWidth);
      header.classList.remove('wa-header-measuring');
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    };
    let lastWidth = 0;
    new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (Math.abs(width - lastWidth) < 1) return;
      lastWidth = width;
      schedule();
    }).observe(row);
    new MutationObserver(schedule).observe(nav, {childList: true, characterData: true, subtree: true});
    new MutationObserver(schedule).observe(right, {childList: true, characterData: true, subtree: true});
    window.addEventListener('resize', schedule, {passive: true});
    document.fonts?.ready.then(schedule);
    schedule();
  }
  document.querySelectorAll('.site-header').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.site-header').forEach(setup));
})();
